const SEMVER_PATTERN = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/

function semverParts(version: string): readonly [number, number, number] {
  const match = SEMVER_PATTERN.exec(version)
  if (!match) throw new Error(`Version must use major.minor.patch format, received "${version}"`)
  const parts = match.slice(1).map(Number)
  const major = parts[0]
  const minor = parts[1]
  const patch = parts[2]
  if (major === undefined || minor === undefined || patch === undefined) {
    throw new Error(`Version "${version}" is missing a semantic version part`)
  }
  return [major, minor, patch]
}

export function compareSemver(first: string, second: string): -1 | 0 | 1 {
  const firstParts = semverParts(first)
  const secondParts = semverParts(second)
  for (let index = 0; index < firstParts.length; index += 1) {
    const difference = (firstParts[index] ?? 0) - (secondParts[index] ?? 0)
    if (difference < 0) return -1
    if (difference > 0) return 1
  }
  return 0
}
